export default __webpack_public_path__ + "static/media/logout.335d2fd6.svg";